import { render, staticRenderFns } from "./Customer-profile.vue?vue&type=template&id=2381909d&scoped=true&"
import script from "./Customer-profile.vue?vue&type=script&lang=js&"
export * from "./Customer-profile.vue?vue&type=script&lang=js&"
import style0 from "./Customer-profile.vue?vue&type=style&index=0&id=2381909d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381909d",
  null
  
)

export default component.exports